var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[(_vm.visible)?_c('div',{staticClass:"toast-container",class:_vm.type},[_c('div',{staticClass:"toast-content"},[_c('div',{staticClass:"toast-message"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"toast-close",on:{"click":_vm.hideToast}},[_vm._v("×")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }